import { render, staticRenderFns } from "./ShoppingListsNoData.vue?vue&type=template&id=e2fc1f14&"
import script from "./ShoppingListsNoData.vue?vue&type=script&lang=js&"
export * from "./ShoppingListsNoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports